import axios from '@/axios.js'

export default {
  async fetchPaymentList ({ commit }) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.get('/payment/list')
      
      // Handle different response structures
      let paymentList = []
      if (response.data) {
        if (Array.isArray(response.data)) {
          paymentList = response.data
        } else if (response.data.data && Array.isArray(response.data.data)) {
          paymentList = response.data.data
        } else if (response.data.result && Array.isArray(response.data.result)) {
          paymentList = response.data.result
        } else if (response.data.list && Array.isArray(response.data.list)) {
          paymentList = response.data.list
        }
      }
      
      commit('SET_PAYMENT_LIST', paymentList)
    } catch (error) {
      console.error('Error fetching payment list:', error)
      // On error, keep empty array - fallback will be used
      commit('SET_PAYMENT_LIST', [])
    } finally {
      commit('SET_LOADING', false)
    }
  }
}
